export const displayGameMode = (gameMode) => {
    switch (gameMode) {
        case 'overall': return 'Overall';
        case 'moving': return 'Moving';
        case 'nomove': return 'No move';
        case 'nmpz': return 'NMPZ';
    }
    return null;
}
export const displayRankingType = (rankingType) => {
    switch (rankingType) {
        case 'regular': return 'Regular';
        case 'pro': return 'Pro';
        case 'elite': return 'Elite';
    }
    return null;
}